import axios from '@/plugins/axios.js'

export function saveOrUpdateCust(param) {
    if (param.id) {
        return axios.post("customer/update", param);
    } else {
        return axios.post("customer/save", param);
    }
}

export function removeCust(id) {
    return axios.delete("customer/remove/" + id);
}

export function list(params) {
    return axios.get("customer/query", { params: params });
}

export function listAll(){
    return axios.get("customer/queryAll");
}